<template>
  <dn-link
    v-if="visible"
    class="dn-subscribe-button button"
    :text="t('Subscribe')"
    :href="subscriptionLink"
    external
  />
</template>
<script setup lang="ts">
import { useProfileLoginStore } from '~/store/profileLogin';
const { t } = useI18n();
const visible = useProfileLogin(useProfileLoginStore().loginStatus).shouldShowAbonnerButton;
const subscriptionLink = ref(useRuntimeConfig().public?.subscriptionLink);
</script>
<style lang="scss">
.dn-subscribe-button {
  visibility: visible;
}
</style>
